module.exports = __webpack_public_path__ + "img/default.876fe713.png";